export default {
  locale: 'en-gb',
  dateFormat: 'll',
  timeFormat: 'HH:mm',
}
